export const PATH_HOME = '/';
export const PATH_LOGIN = '/login';
